import axios from "axios";
import { compress } from "../helpers/common.helper";

const apiUri = import.meta.env.GATEWAY_URI;

export default function useBlogs() {
  const getBlog = async (id) => {
    const result = await axios.get(`${apiUri}/api/v1/blogs/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return result.data.data;
  };
  const queryBlog = async (filter, page, limit, project, sort) => {
    const reqBody = {};
    if (filter) reqBody.filter = filter;
    if (page) reqBody.page = page;
    if (limit) reqBody.limit = limit;
    if (project) reqBody.project = project;
    if (sort) reqBody.sort = sort;
    const _body = compress(JSON.stringify(reqBody));

    const result = await axios.post(`${apiUri}/api/v1/blogs/query`, _body, {
      headers: {
        "Content-Type": "text/plain",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    return result.data;
  };
  const createBlog = async (body) => {
    const _body = compress(JSON.stringify(body));

    const result = await axios.post(`${apiUri}/api/v1/blogs`, _body, {
      headers: {
        "Content-Type": "text/plain",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    return result?.data?.data;
  };

  const patchBlog = async (blogId, body) => {
    const _body = compress(JSON.stringify(body));

    const result = await axios.patch(
      `${apiUri}/api/v1/blogs/${blogId}`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result.data.data;
  };

  const addBlockViews = async (blogId ) => {
    const result = await axios.patch(
      `${apiUri}/api/v1/blogs/${blogId}/views`,
      null,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result.data.data;
  };


  const deleteBlog = async (blogId) => {
    const result = await axios.delete(`${apiUri}/api/v1/blogs/${blogId}`, {
      headers: {
        "Content-Type": "text/plain",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    return result.data;
  };

  const uploadBlogCover = async (id, file) => {
    let data = new FormData();
    let date = new Date();
    data.append("file", file, `Blog_Cover_${date}`);

    const result = await axios.post(
      `${apiUri}/api/v1/blogs/${id}/cover/upload`,
      data,
      {
        maxBodyLength: Infinity,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result.data.data;
  };

  const uploadBlogImage = async (id, file) => {
    let data = new FormData();
    let date = new Date();
    data.append("file", file, `Blog_Image_${date}`);

    const result = await axios.patch(
      `${apiUri}/api/v1/blogs/${id}/image/upload`,
      data,
      {
        maxBodyLength: Infinity,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result.data.data;
  };

  return {
    queryBlog: queryBlog,
    getBlog: getBlog,
    createBlog: createBlog,
    patchBlog: patchBlog,
    uploadBlogCover: uploadBlogCover,
    uploadBlogImage: uploadBlogImage,
    deleteBlog: deleteBlog,
    addBlockViews
  };
}
